// sticky-cart.js (HARDENED: prevents double-load class redeclare + safer init)
(function () {
  'use strict';

  // Prevent double-execution if script is included twice
  if (window.__innernerdStickyCartLoaded) return;
  window.__innernerdStickyCartLoaded = true;

  class StickyCart {
    constructor() {
      this.stickyCartCount = document.getElementById('sticky-cart-count');
      this.stickyCartIcon = document.getElementById('sticky-cart-icon');
      this.header = document.querySelector('header, .header, .shopify-section-header');
      this._intervalId = null;
      this.init();
    }

    init() {
      // Subscribe to cart update events if PubSub exists
      if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) {
        window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, () => this.updateCartCount());
        window.subscribe(window.PUB_SUB_EVENTS.cartError, () => this.updateCartCount());
      }

      // Update count on page load
      this.updateCartCount();

      // Scroll detection for header visibility
      this.initScrollDetection();

      // Fallback: periodic update (keep light)
      this._intervalId = window.setInterval(() => this.updateCartCount(), 2000);
    }

    initScrollDetection() {
      if (!this.stickyCartIcon) return;

      // Initially hide the cart icon
      this.stickyCartIcon.classList.remove('show');

      let ticking = false;
      const handleScroll = () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(() => {
          this.checkHeaderVisibility();
          ticking = false;
        });
      };

      window.addEventListener('scroll', handleScroll, { passive: true });
      this.checkHeaderVisibility();
    }

    checkHeaderVisibility() {
      if (!this.header || !this.stickyCartIcon) return;

      const headerRect = this.header.getBoundingClientRect();
      const headerBottom = headerRect.bottom;

      if (headerBottom <= 0) this.stickyCartIcon.classList.add('show');
      else this.stickyCartIcon.classList.remove('show');
    }

    updateCartCount() {
      if (!window.routes || !window.routes.cart_url) return;

      fetch(`${window.routes.cart_url}.js`, { credentials: 'same-origin' })
        .then((response) => response.json())
        .then((cart) => {
          if (!this.stickyCartCount) return;

          const itemCount = Number(cart.item_count || 0);
          const currentCount = Number(parseInt(this.stickyCartCount.textContent, 10) || 0);

          if (itemCount !== currentCount) {
            this.stickyCartCount.textContent = String(itemCount);
            this.stickyCartCount.classList.add('updated');
            window.setTimeout(() => this.stickyCartCount && this.stickyCartCount.classList.remove('updated'), 300);
          }

          if (itemCount === 0) this.stickyCartCount.style.display = 'none';
          else this.stickyCartCount.style.display = 'flex';
        })
        .catch((error) => {
          console.warn('sticky-cart: update failed', error);
        });
    }
  }

  // Global instance for external access
  let stickyCartInstance = null;

  document.addEventListener('DOMContentLoaded', () => {
    if (!document.getElementById('sticky-cart-count')) return;
    stickyCartInstance = new StickyCart();

    // Optional global helper
    window.updateStickyCart = function () {
      if (stickyCartInstance) stickyCartInstance.updateCartCount();
    };
  });
})();
